import { Link, useNavigate } from 'react-router-dom';
import { posts } from '@/mocks/posts';
import { hotTags } from '@/mocks/channels';
import { stats } from '@/mocks/site';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleRandom = () => {
    const pick = posts[Math.floor(Math.random() * posts.length)];
    navigate(`/post/${pick.id}`);
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20coral%20abstract%20background%20with%20soft%20rounded%20geometric%20shapes%2C%20stylized%20watermelon%20slices%20and%20popcorn%20silhouettes%2C%20deep%20warm%20shadows%20on%20the%20left%20side%20for%20text%20contrast%2C%20cozy%20playful%20editorial%20illustration%2C%20no%20text%2C%20rich%20saturated%20warm%20tones%20with%20cream%20highlights&width=1800&height=1000&seq=chigua-hero-01&orientation=landscape"
          alt="糖心吃瓜网首屏插画 - 暖色吃瓜与下饭场景"
          title="糖心吃瓜网 下饭解闷的摸鱼笑料合集"
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
      </div>

      <div className="relative mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-100/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur">
              <span className="flex h-1.5 w-1.5 rounded-full bg-primary-400" />
              每天 20:00 准时上新 · 已更新 2.4 万条笑料
            </span>

            <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
              糖心吃瓜网
              <span className="mt-3 block text-2xl text-primary-300 md:text-4xl">
                下饭 · 解闷 · 摸鱼必备的笑料合集
              </span>
            </h1>

            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              饭点不知道配什么？这里集合了热点瓜、沙雕图、段子与短视频，随手点开一条就能喷饭。
              专治无聊空虚，让你在摸鱼间隙也能乐呵两分钟。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/channel/regua"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-base" />
                开始吃瓜
              </Link>
              <button
                type="button"
                onClick={handleRandom}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                <i className="ri-shuffle-line w-4 h-4 flex items-center justify-center text-base" />
                手气不错，随机一条
              </button>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="text-xs text-background-300">大家都在看：</span>
              {hotTags.slice(0, 6).map((tag) => (
                <Link
                  key={tag}
                  to={`/?q=${encodeURIComponent(tag)}#stream`}
                  className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-200 transition-colors hover:border-primary-400 hover:text-primary-300"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-2xl border border-background-100/15 bg-background-50/10 p-5 backdrop-blur-md md:p-6">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2 text-sm font-medium text-background-50">
                  <i className="ri-live-line w-4 h-4 flex items-center justify-center text-lg text-accent-400" />
                  此刻最多人在看
                </span>
                <span className="text-xs text-background-300">实时</span>
              </div>
              <ul className="mt-4 space-y-3">
                {posts.slice(0, 4).map((post, index) => (
                  <li key={post.id}>
                    <Link
                      to={`/post/${post.id}`}
                      className="group flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-background-50/10"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                          index === 0
                            ? 'bg-accent-500 text-background-50'
                            : 'bg-background-50/15 text-background-100'
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="line-clamp-1 text-sm text-background-100 group-hover:text-primary-300">
                        {post.title}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/channel/regua"
                className="mt-4 flex items-center justify-center gap-2 rounded-md border border-background-100/20 py-2.5 text-xs text-background-200 transition-colors hover:bg-background-50/10"
              >
                查看完整榜单
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 border-t border-background-100/15 pt-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <p className="font-heading text-2xl text-primary-300 md:text-3xl">
                {item.value}
                <span className="ml-1 text-sm text-background-300">{item.unit}</span>
              </p>
              <p className="mt-1 text-xs text-background-300 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}